import { render, staticRenderFns } from "./KrPage.vue?vue&type=template&id=357473b3&scoped=true"
import script from "./KrPage.vue?vue&type=script&lang=js"
export * from "./KrPage.vue?vue&type=script&lang=js"
import style0 from "./KrPage.vue?vue&type=style&index=0&id=357473b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357473b3",
  null
  
)

export default component.exports